import CTracker from "components/CTracker";
import { TrackerContextProvider } from "components/CTracker/useTrackerContext";

const CoborrowerTracker: React.FC = () => {
  return (
    <TrackerContextProvider>
      <CTracker isBorrower={false} />
    </TrackerContextProvider>
  );
};

export default CoborrowerTracker;
